export const waitV2DocumentationMarkdown = `
# Wait for/until time

Waits for a specified amount of time.

The amount of time to wait can be defined as either:
 - a pre-defined wait duration; or
 - a dynamic wait duration or target datetime until which to wait.

Only one of the above values can be specified.

## Pre-defined wait duration

Pre-defined duration can be specified in any of the following units using the unit selection menu:

- Years
- Weeks
- Days
- Hours
- Minutes
- Seconds

## Dynamic wait duration or target datetime

**Dynamic** means either:
- a pre-defined value; or
- using an output value from a previous block via \`{{...}}\` notation (e.g., \`{{scriptBlock.waitDuration}}\`).

The value must be either:
- number of milliseconds to wait (e.g., \`15000\`); or
- an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) formatted target datetime until which to wait (e.g., \`2025-09-22T17:40:15Z\`).

Here are some examples of ISO 8601 datetimes:

- **5:40 PM in UTC:** \`2025-09-22T17:40:00Z\`
- **7:40 AM PDT (UTC-7):** \`2025-09-22T07:40:00-07:00\`
- **5:40 PM in UTC+2 Timezone:** \`2025-09-22T17:40:00+02:00\`
`;
